import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import './ParkingStatus.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { Loading, Problem } from '../../components';
import { fetchCreatePayment, fetchUpdatePayment, fetchGetPaymentDetail, fetchGetParkingStatus, fetchGetIoTDevices, fetchIoTPublishInformation, fetchUpdateStatusCarExit } from '../../actions';
import {
  carImage,
  vehicleLicensePlate,
  timeIn,
  timeFormatHHMM,
  isMember,
  dateDMYYYYFormat,
  dateDDMMYYYYFormat,
  parkingTimeTotal,
  msToHHMM,
  msToHM,
  memberNote,
  freeParkingTimeTotal,
  validateToShowDash,
  isOverdue,
  historyPayment,
  parkingUntil,
  parkingOverTime,
  problemColor,
  problemName,
  parkingID,
  Modal,
  carOut,
  getTimeHHMMSS,
  qrCode,
  statusPaid,
  errorMessage,
  statusReady,
  minutesToHr,
  vehicleType,
  paymentTotalAmount,
  parkingAmount,
  overnightAmount,
  createPaymentTotalAmount,
  overnightTime,
  validateMoney,
  minutesToHM,
  vehicleProvince,
  formatParkingRefNo,
  parkingRefNo, parkingDayConfig,
  Dropdown,
  buildingRefNo,
  buildingID,
  dateYYYYMMDD,
} from '../../helpers';

class ParkingStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showModalProblem': false,
      'showModalPayment': false,
      'showModalOpenGate': false,
      'type': null,
      'updateProblem': null,
      'activeReload': false,
      'logPayment': null,
      'logProblem': null,
      'position': null,
    };
    this.requestCheckStatus = null;
    this.cancelPayment = null;
    this.activeReload = null;
    this.positionRef = createRef();
  }

  UNSAFE_componentWillMount() {
    const { getParkingProblems, getParkingStatus, 'match': { params } } = this.props;

    if (getParkingProblems.data) {
      this.setState({ 'logProblem': this.handleLogProblems() });
    }
    if (getParkingStatus.data) {
      this.setState({ 'logPayment': this.handleLogHistoryPayment() });
    }
        
    this.props.dispatch(fetchGetIoTDevices(params.buildingID, commonConstant.iotDeviceParkingGate));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { createPayment, updatePayment, getPaymentDetail, getParkingProblems, getParkingStatus, publishIoTInformation, carExit } = this.props;
    const { type } = this.state;

    if (nextProps.createPayment && nextProps.createPayment !== createPayment) {
      if (nextProps.createPayment.status === 200) {
        return this.setState({ 'showModalPayment': true, 'loading': false });
      }
    } else if (nextProps.updatePayment && nextProps.updatePayment !== updatePayment) {
      if (nextProps.updatePayment.status === 200) {
        return this.setState({ 'showModalPayment': true, 'loading': false });
      }
    } else if (nextProps.getPaymentDetail && nextProps.getPaymentDetail !== getPaymentDetail) {
      if (nextProps.getPaymentDetail.status === 200) {
        if (statusPaid(nextProps.getPaymentDetail.data)) {
          this.handleClearTime();
          return this.setState({ 'showModalPayment': true, 'type': commonConstant.successPayment, 'loading': false });
        } else if (statusReady(nextProps.getPaymentDetail.data)) {
          return null;
        }
        return this.setState({ 'showModalPayment': true, 'type': commonConstant.warningPayment, 'loading': false });
      }
    } else if (nextProps.getParkingStatus && nextProps.getParkingStatus !== getParkingStatus) {
      if (type === commonConstant.updatePayment || type === commonConstant.successPayment) {
        this.setState({ 'showModalPayment': false, 'type': null, 'activeReload': false, 'loading': false });
        this.props.showReceipts(nextProps.getParkingStatus.data.previousPayment ? 0 : null);
      }
      return this.setState({ 'logPayment': this.handleLogHistoryPayment(nextProps.getParkingStatus) });
    } else if (nextProps.getParkingProblems && nextProps.getParkingProblems !== getParkingProblems) {
      return this.setState({ 'logProblem': this.handleLogProblems(nextProps.getParkingProblems) });
    } if (nextProps.publishIoTInformation && nextProps.publishIoTInformation && nextProps.publishIoTInformation !== publishIoTInformation) {
      this.setState({ 'loading': false, 'showModalOpenGate': false });     
    } else if (nextProps.carExit && nextProps.carExit && nextProps.carExit !== carExit) {
      return this.setState({ 'loading': false });
    }
  }

  componentWillUnmount() {
    const element = document.getElementsByTagName('body');

    this.handleClearTime();
    element[0].removeAttribute('class');
    element[0].removeAttribute('style');
  }

  handleParkingTime = () => {
    const { getParkingStatus } = this.props;

    return (
      <>
        <div className="box-item">
          <div className="title" id="parking-time-in-date-title">
            วันที่เข้าจอด
          </div>
          <div className="value" id="parking-time-in-date">
            {validateToShowDash(dateDDMMYYYYFormat(timeIn(getParkingStatus.data)))}
          </div>
        </div>
        <div className="box-item">
          <div className="title" id="parking-time-in-time-title">
            เวลาเข้าจอด
          </div>
          <div className="value" id="parking-time-in-time">
            {validateToShowDash(timeFormatHHMM(timeIn(getParkingStatus.data)))}
          </div>
        </div>
        <div className="box-item">
          <div className="title" id="parking-time-total-title">
            เวลาจอดสุทธิ
          </div>
          <div className="value" id="parking-time-total">
            {validateToShowDash(msToHHMM(parkingTimeTotal(getParkingStatus.data)))}
          </div>
        </div>
      </>
    );
  }

  handleVehicleDetail = () => {
    const { getParkingStatus } = this.props;

    return (
      <div className="vehicle-detail">
        <img className="image-car" id="vehicle-image" src={carImage(getParkingStatus.data)} alt=""/>
        <div className="box-license-plate">
          <div className="license-plate"
            id="vehicle-license-plate">{vehicleLicensePlate(getParkingStatus.data) !== '00000' ? vehicleLicensePlate(getParkingStatus.data) : formatParkingRefNo(parkingRefNo(getParkingStatus.data))}</div>
          <div className="province" id="vehicle-province">{vehicleProvince(getParkingStatus.data)}</div>
          <div className="car-in">
            <span className="icon far fa-clock"/>
            <span className="time" id="time">ณ เวลา {timeFormatHHMM(new Date())}</span>
          </div>
        </div>
      </div>
    );
  }

  handleMember = () => {
    const { getBuildingByRefNo, getParkingStatus } = this.props;

    return (
      <div className="ParkingStatus">
        {this.handleVehicleDetail()}
        <div className="box-member">
          <span className="icon icon-crown" id="member-icon"/>
          <span className="box-text">
            <div className="title" id="member-title">คุณเป็นสมาชิก</div>
            <div className="description" id="member-description">ไม่มีค่าบริการเพิ่มเติม</div>
          </span>
        </div>
        <div className="detail">
          {this.handleParkingTime()}
        </div>
        <div className="box-member-note">
          <div className="title" id="member-note-title">หมายเหตุ</div>
          <div className="description" id="member-note">
            {validateToShowDash(memberNote(getBuildingByRefNo, vehicleType(getParkingStatus.data)))}
          </div>
        </div>
      </div>
    );
  }

  handleLogHistoryPayment = newGetParkingStatus => {
    const { getParkingStatus } = this.props;
    const data = newGetParkingStatus ? newGetParkingStatus : getParkingStatus;

    if (!historyPayment(data.data)) {
      return null;
    }

    let defaultFreeParkingTime = 0;
    let sumParkingTime = 0;
    const ParkingTimeIn = timeIn(data.data) ? timeIn(data.data) : null;

    return data.data.previousPayment.reverse().map((ele, index) => {
      sumParkingTime += ele.paymentTotalParkingFeeMinutes + ele.paymentTotalBuildingFreeParkingMinutes + ele.paymentTotalRedemptionMinutes - (ele.paymentTotalRedemptionMinutes === 0 ? 0 : defaultFreeParkingTime);
      defaultFreeParkingTime += ele.paymentTotalBuildingFreeParkingMinutes;
      return (
        <tr key={randomNumber()}>
          <td id={`payment-date-${index}`}>{validateToShowDash(dateDMYYYYFormat(ele.createdAt))}</td>
          <td id={`payment-time-${index}`}>{validateToShowDash(timeFormatHHMM(ele.createdAt))}</td>
          <td id={`payment-amount-${index}`}>
            {validateToShowDash(paymentTotalAmount(ele) || paymentTotalAmount(ele) === 0 ? paymentTotalAmount(ele).toLocaleString() : null)} บาท
          </td>
          <td
            id={`payment-parking-time-${index}`}>{validateToShowDash(minutesToHr(ele.paymentTotalParkingFeeMinutes))} ชม.
          </td>
          <td id={`payment-free-parking-${index}`}>
            {validateToShowDash(minutesToHM(ele.paymentTotalBuildingFreeParkingMinutes + ele.paymentTotalRedemptionMinutes - (ele.paymentTotalRedemptionMinutes === 0 ? 0 : defaultFreeParkingTime)))}
          </td>
          <td id={`payment-parking-until-${index}`}>
            {validateToShowDash(timeFormatHHMM(new Date(ParkingTimeIn).setMinutes(new Date(ParkingTimeIn).getMinutes() + sumParkingTime)))}
          </td>
        </tr>
      );
    });
  }

  handleLogProblems = newGetParkingProblems => {
    const { getParkingProblems } = this.props;
    const data = newGetParkingProblems ? newGetParkingProblems : getParkingProblems;

    if (!data.data) {
      return null;
    }

    return data.data.map((ele, index) => (
      <div className="log-problem" key={randomNumber()}>
        <div className="box-title">
          <span className={`x2 ${problemColor(ele)}`} id={`problem-type-${index}`}>
            {problemName(ele)}
          </span>
          <div className="box-icon">
            <span
              id={`update-problem-${index}`}
              className="icon fas fa-edit"
              onClick={() => this.handleShowModalProblem(commonConstant.updateProblem, ele)}
            />
            <span
              id={`delete-problem-${index}`}
              className="icon far fa-trash-alt"
              onClick={() => this.handleShowModalProblem(commonConstant.deleteProblem, ele)}
            />
          </div>
        </div>
        <div className="description" id={`problem-detail-${index}`}>- {ele.problemDetail}</div>
      </div>
    ));
  }

  handleShowModalProblem = (type, updateProblem) => this.setState({ 'showModalProblem': true, type, updateProblem });

  handleCloseModalProblem = () => this.setState({ 'showModalProblem': false, 'type': null, 'updateProblem': null });

  handleShowModalPayment = type => {
    const { getParkingStatus } = this.props;

    if (!isOverdue(getParkingStatus.data)) {
      return null;
    }

    this.setState({ type, 'loading': true, 'activeReload': false });
    if (type === commonConstant.cashPayment) {
      return this.props.dispatch(fetchCreatePayment({
        'gatewayMethod': commonConstant.methodCash,
        'gatewayType': commonConstant.gatewayManual,
        'parkingID': parkingID(getParkingStatus.data),
      }));
    } else if (type === commonConstant.ezyPayment) {
      this.handleSetTime();
      return this.props.dispatch(fetchCreatePayment({
        'gatewayMethod': commonConstant.methodQRCode,
        'gatewayType': commonConstant.gatewayKBank,
        'parkingID': parkingID(getParkingStatus.data),
      }));
    } else if (type === commonConstant.warningPayment || type === commonConstant.successPayment) {
      return this.setState({ 'loading': false });
    }
    return null;
  }

  handleCloseModalPayment = () => {
    const { type } = this.state;
    const { getParkingStatus } = this.props;

    this.handleClearTime();
    switch (type) {
      case commonConstant.cashPayment:
        return this.setState({ 'showModalPayment': false, 'type': null, 'activeReload': false });
      case commonConstant.ezyPayment:
        return this.setState({ 'showModalPayment': false, 'type': null, 'activeReload': false });
      case commonConstant.warningPayment:
        return this.setState({ 'showModalPayment': false, 'type': null, 'activeReload': false });
      case commonConstant.updatePayment:
      case commonConstant.successPayment:
        this.setState({ 'loading': true });
        return this.props.dispatch(fetchGetParkingStatus(parkingID(getParkingStatus.data)));
      default:
        return;
    }
  }

  handleHeaderModalPayment = () => {
    const { type } = this.state;

    switch (type) {
      case commonConstant.cashPayment:
        return 'ยืนยันชำระเงินสด';
      case commonConstant.ezyPayment:
        return 'EZY Payment';
      case commonConstant.warningPayment:
        return 'EZY Payment';
      case commonConstant.successPayment:
        return 'EZY Payment';
      case commonConstant.updatePayment:
        return 'ชำระเงินสำเร็จ';
      default:
        return null;
    }
  }

  handleBodyModalPayment = () => {
    const { type, loading, activeReload } = this.state;
    const { getParkingStatus, createPayment, getPaymentDetail } = this.props;

    if (!createPayment.data) {
      return null;
    }

    switch (type) {
      case commonConstant.cashPayment:
        return (
          <div className="cash-payment">
            {loading ? <Loading/> : null}
            <div className="icon icon-cash"/>
            <div className="detail-row">
              <span className="label">ชำระเงินจำนวน</span>
              <span className="value green" id="payment-total-amount">
                {validateToShowDash(createPaymentTotalAmount(createPayment.data) ? createPaymentTotalAmount(createPayment.data).toLocaleString() : null)} THB
              </span>
            </div>
            <div className="detail-row">
              <span className="label">เลขทะเบียนรถ</span>
              <span className="value" id="payment-license-plate">{vehicleLicensePlate(getParkingStatus.data)}</span>
            </div>
            <div className="box-btn">
              <Button className="btn-confirm btn-secondary" id="btn-paid" onClick={this.handleUpdateStatusPayment}>
                บันทึก
              </Button>
              <span className="btn-cancel" id="btn-cancel" onClick={this.handleCloseModalPayment}>
                ยกเลิก
              </span>
            </div>
          </div>
        );
      case commonConstant.updatePayment:
        return (
          <div className="update-payment">
            {loading ? <Loading/> : null}
            <span className="icon icon-payment" id="icon-payment"/>
            <div className="title" id="parking-until-time-title">
              จอดได้ถึงเวลา
            </div>
            <div className="time" id="parking-until-time">
              {validateToShowDash(getTimeHHMMSS(carOut(createPayment.data, getParkingStatus.data)))} น.
            </div>
            <div className="button-container">
              <Button className="btn-secondary" id="btn-ok" onClick={this.handleCloseModalPayment}>
              ตกลง
              </Button>
            </div>        
          </div>
        );
      case commonConstant.ezyPayment:
        return (
          <div className="ezy-payment">
            {loading ? <Loading/> : null}
            <div className="detail-row">
              <span className="label">ชำระเงินจำนวน</span>
              <span className="value green" id="payment-total-amount">
                {validateToShowDash(createPaymentTotalAmount(createPayment.data) ? createPaymentTotalAmount(createPayment.data).toLocaleString() : null)} THB
              </span>
            </div>
            <div className="detail-row">
              <span className="label">เลขทะเบียนรถ</span>
              <span className="value" id="payment-license-plate">{vehicleLicensePlate(getParkingStatus.data)}</span>
            </div>
            <img className="qrcode" id="payment-qr-code" src={`data:image/png;base64,${qrCode(createPayment.data)}`}
              alt=""/>
            <Button id="payment-reload-qr" className={`btn-secondary${!activeReload ? ' hide' : ''}`}
              onClick={this.handleReloadQRCode}>
              <span className="icon fas fa-redo"/>
              Reload QR
            </Button>
          </div>
        );
      case commonConstant.warningPayment:
        return (
          <div className="warning-payment">
            {loading ? <Loading/> : null}
            <img className="image" id="icon-payment-fail" src={commonConstant.promptpayErrorImg} alt=""/>
            <div className="title" id="payment-fail-title">
              {
                statusReady(getPaymentDetail.data) ?
                  `ไม่ได้รับการชำระเงินภายในเวลาที่กำหนด
                    (10 นาที)
                  กรุณาลองอีกครั้ง`
                  : errorMessage(getPaymentDetail.data)
              }
            </div>
            <div className="box-btn">
              <Button className="btn-try" id="btn-try"
                onClick={() => this.handleShowModalPayment(commonConstant.ezyPayment)}>
                ลองอีกครั้ง
              </Button>
              <span className="btn-thirdary btn-cash" id="btn-cash"
                onClick={() => this.handleShowModalPayment(commonConstant.cashPayment)}>
                ชำระด้วยเงินสด
              </span>
            </div>
          </div>
        );
      case commonConstant.successPayment:
        return (
          <div className="success-payment">
            {loading ? <Loading/> : null}
            <img className="image" src={commonConstant.promptpaySuccessImg} alt=""/>
            <div className="title" id="payment-success-title">
              ชำระเงินผ่าน EZY Payment สำเร็จ
            </div>
            <div className="box-time" id="payment-success-until-tile">
              จอดได้ถึงเวลา {validateToShowDash(getTimeHHMMSS(carOut(createPayment.data, getParkingStatus.data)))} น.
            </div>
            <Button className="btn-primary" onClick={this.handleCloseModalPayment}>OK</Button>
          </div>
        );
      default:
        return null;
    }
  }

  handleUpdateStatusPayment = () => {
    const { createPayment } = this.props;

    this.setState({ 'loading': true, 'type': commonConstant.updatePayment });
    return this.props.dispatch(fetchUpdatePayment(createPayment.data.paymentID));
  }

  handleSetTime = () => {
    this.handleClearTime();
    this.activeReload = setTimeout(() => this.setState({ 'activeReload': true }), 30000);
    this.requestCheckStatus = setInterval(() => this.handleCheckStatusPayment(), 5000);
    this.cancelPayment = setTimeout(() => this.handleCancelPayment(), 300000);
  }

  handleClearTime = () => {
    clearTimeout(this.activeReload);
    clearInterval(this.requestCheckStatus);
    clearTimeout(this.cancelPayment);
  }

  handleCheckStatusPayment = () => {
    const { createPayment } = this.props;

    this.props.dispatch(fetchGetPaymentDetail(createPayment.data.paymentID));
  }

  handleReloadQRCode = () => {
    const { activeReload } = this.state;

    if (!activeReload) {
      return null;
    }
    this.handleClearTime();
    this.setState({ 'loading': true });
    return this.handleShowModalPayment(commonConstant.ezyPayment);
  }

  handleCancelPayment = () => {
    this.handleShowModalPayment(commonConstant.warningPayment);
    return this.handleClearTime();
  }

  handleOpenGate = () => {
    const { position } = this.state;
    const { getParkingStatus } = this.props;

    if (position && position.value) {
      this.setState({ 'loading': true });
      const time = new Date();

      this.props.dispatch(fetchIoTPublishInformation({
        'iotDeviceType': commonConstant.iotDeviceParkingGate,
        'parkingGate': {
          'buildingID': buildingID(this.props.getBuildingByRefNo),
          'parkingGateLocation': commonConstant.iotPositionOut,
          'parkingGatePosition': position.value,
        },
      }, buildingRefNo(this.props.getBuildingByRefNo)));
      this.props.dispatch(fetchUpdateStatusCarExit(parkingID(getParkingStatus.data), { 'parkingTimeOut': `${dateYYYYMMDD(time)} ${getTimeHHMMSS(time)}`, 'parkingGateOut': `OUT-${position.value}` }));

      this.setState({ 'loading': true });
    }
  }

  handleBodyModalOpenGate = () => {
    const { iotDevices } = this.props;
    const { position } = this.state; 
    
    return <div className="open-gate-modal">
      <div className="item">
        <div className="title">Position</div>
        <Dropdown
          id="parking-gate-position"
          template="a"
          placeholder="Position"          
          value={position && position.value}
          valueShow={position && position.label}
          ref={this.positionRef}
        >
          {
            iotDevices.data[commonConstant.iotPositionOut].map((ele, index) => (
              <div
                id={`parking-gate-position-${index}`}
                key={`parking-gate-position-${index}`}
                className="item"
                onClick={() => {
                  this.setState({
                    'position' :
                    {        
                      'label': ele.buildingIotDevicePosition,
                      'value': ele.buildingIotDevicePosition,
                    },
                  });
                  this.positionRef.current.handleShowItem();
                }}
              >
                {ele.buildingIotDevicePosition}
              </div>
            ))
          }
        </Dropdown>
      </div>
      <div className="open-gate-modal-btn-box">
        <Button
          id="btn-open-gate"            
          onClick={() => this.handleOpenGate()}
        >
          เปิดประตู
        </Button>
      </div>
    </div>;
  };

  render() {
    const { match, getBuildingByRefNo, getParkingStatus, getParkingProblems, getProblems, getVehicleLicensePlate, iotDevices } = this.props;
    const { showModalProblem, type, updateProblem, showModalPayment, loading, logPayment, logProblem, showModalOpenGate } = this.state;

    if (!getParkingStatus.data || !getBuildingByRefNo || !getParkingProblems.data || !getProblems || !iotDevices) {
      return <Loading/>;
    } else if (isMember(getParkingStatus.data, match.params.buildingID) && paymentTotalAmount(getParkingStatus.data) === 0 && (parkingDayConfig(getBuildingByRefNo, getParkingStatus.data.parking.parkingGateIn).chargeCustomer === commonConstant.chargeTypeNoCharge || parkingDayConfig(getBuildingByRefNo, getParkingStatus.data.parking.parkingGateIn).chargeCustomer === commonConstant.chargeTypeVisitor)) {
      return this.handleMember();
    }

    return (
      <div className="ParkingStatus">
        {loading ? <Loading/> : null}
        <Problem
          x2
          show={showModalProblem}
          type={type}
          handleCloseModal={this.handleCloseModalProblem}
          parkingID={parkingID(getParkingStatus.data)}
          problem={showModalProblem ? updateProblem : null}
          handleShowModalDelete={() => this.handleShowModalProblem(commonConstant.deleteProblem, updateProblem)}
        />
        <Modal x2 show={showModalOpenGate} header={'เปิดประตู'}
          handleToggle={() => this.setState({ 'showModalOpenGate': false })}>
          {this.handleBodyModalOpenGate()}
        </Modal>
        <Modal x2 show={showModalPayment} header={this.handleHeaderModalPayment()}
          handleToggle={this.handleCloseModalPayment}>
          {this.handleBodyModalPayment()}
        </Modal>
        {this.handleVehicleDetail()}
        <div className="parking-detail">
          <div className="parking-total">
            <div className="parking-time">
              <div id="parking-time-amount-title" className="parking-time-amount-title">
                เวลาที่จอดเกิน
              </div>
              <div id="parking-time-amount"
                className={`parking-time-amount${isOverdue(getParkingStatus.data) ? ' over' : ''}`}>
                {
                  isOverdue(getParkingStatus.data) ?
                    validateToShowDash(msToHM(parkingOverTime(getParkingStatus.data)))
                    : msToHM(0)
                }
              </div>
            </div>
            <div className="parking-amount">
              <div id="parking-amount-title" className="parking-amount-title">
                ค้างชำระ
              </div>
              <div id="parking-amount-total"
                className={`parking-amount-total${isOverdue(getParkingStatus.data) ? ' over' : ''}`}>
                {
                  isOverdue(getParkingStatus.data) ?
                    validateToShowDash(paymentTotalAmount(getParkingStatus.data) ? paymentTotalAmount(getParkingStatus.data).toLocaleString() : null)
                    : 0
                } บาท
              </div>
            </div>
          </div>
          <div className="parking-time">
            <div className="parking-time-previous-title" id="parking-time-previous-title">
              จากเวลาที่จอดได้ถึงล่าสุด
            </div>
            <div className={`parking-time-previous${isOverdue(getParkingStatus.data) ? ' over' : ''}`}>
              <span className="icon far fa-clock"/>
              <div id="parking-time-previous">
                {validateToShowDash(timeFormatHHMM(parkingUntil(getParkingStatus.data)))} น.
              </div>
            </div>
          </div>
        </div>
        <div className="detail">
          {this.handleParkingTime()}
          <div className="box-item">
            <div className="title" id="parking-free-time-title">
              สิทธิ์จอดฟรี
            </div>
            <div className="value" id="parking-free-time">
              {validateToShowDash(minutesToHM(freeParkingTimeTotal(getParkingStatus.data)))}
            </div>
          </div>
          <div className="box-item">
            <div className="title" id="parking-fee-amount-title">
              ค่าบริการจอดรถ
            </div>
            <div className="value" id="parking-fee-amount">
              {validateMoney(parkingAmount(getParkingStatus.data))} บาท
            </div>
          </div>
          <div className="box-item">
            <div className="title" id="parking-fee-over-night-title">
              ค่าปรับจอดรถค้างคืน
            </div>
            <div className="value" id="parking-fee-over-night">
              {validateMoney(overnightAmount(getParkingStatus.data))} บาท
            </div>
          </div>
          <div className="description" id="parking-note">
            {
              ((getVehicleLicensePlate[0].vehicle.vehicleType === commonConstant.vehicleTypeCar && getBuildingByRefNo.buildingConfig.buildingConfig.config.car.parking.overnight.overnightChargeType === commonConstant.twentyFourHours) || 
               (getVehicleLicensePlate[0].vehicle.vehicleType === commonConstant.vehicleTypeMotorcycle && getBuildingByRefNo.buildingConfig.buildingConfig.config.motorcycle.parking.overnight.overnightChargeType === commonConstant.twentyFourHours)) ? 
                '*ค่าปรับจะถูกเก็บหลังการจอดต่อเนื่อง 24 ชั่วโมง' : 
                validateToShowDash(overnightTime(getBuildingByRefNo, vehicleType(getParkingStatus.data)))
            }
          </div>
        </div>
        <div className="issues-box">
          <div className="title-box">
            <div id="problem-title" className="title">ปัญหาที่พบ</div>
            <span id="btn-create-problem" className="icon fa-solid fa-circle-plus"
              onClick={() => this.handleShowModalProblem(commonConstant.createProblem)}/>
          </div>
          <div className="problem-box">
            {logProblem}
          </div>

        </div>
        <div className={`payment-box${historyPayment(getParkingStatus.data) ? '' : ' hide'}`}>
          <div className="payment-title" id="payment-title">ประวัติการชำระค่าบริการ</div>
          <div className="payment-history">
            <table className="history">
              <thead>
                <tr>
                  <th>วันที่</th>
                  <th>เวลาทำรายการ</th>
                  <th>จำนวนเงิน</th>
                  <th>เวลาจอด</th>
                  <th>สิทธิ์จอดฟรี</th>
                  <th>จอดได้ถึง</th>
                </tr>
              </thead>
              <tbody>
                {logPayment}
              </tbody>
            </table>
          </div>
        </div>
        {
          paymentTotalAmount(getParkingStatus.data) == 0 ?
            <div className="open-gate-btn-box">
              <Button
                id="btn-open-gate"            
                onClick={() => this.setState({ 'showModalOpenGate': true })}
              >
              เปิดประตู
              </Button>
            </div> : null
        }
        <div className="payment-method-box">
          <div className="payment-title" id="payment-title">ช่องทางชำระเงิน</div>
          <Button
            id="btn-payment-by-cash"
            className={`btn-sevendary btn-cash${!isOverdue(getParkingStatus.data) ? ' hide' : ''}`}
            onClick={() => this.handleShowModalPayment(commonConstant.cashPayment)}
          >
            <span className="icon icon-cash"/>
            <div className="title">CASH PAYMENT</div>
          </Button>
          <Button
            id="btn-payment-by-ezy"
            className={`btn-secondary btn-promptpay${!isOverdue(getParkingStatus.data) ? ' hide' : ''}`}
            onClick={() => this.handleShowModalPayment(commonConstant.ezyPayment)}
          >
            <img className="logo" src={commonConstant.promptpayImg} alt=""/>
            <div className="title">EZY PAYMENT</div>
          </Button>
        </div>
      </div>
    );
  }
}

ParkingStatus.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingRefNo': PropTypes.string,
      'buildingID': PropTypes.string,
    }),
  }).isRequired,
  'showReceipts': PropTypes.func.isRequired,
  'getParkingStatus': PropTypes.shape({
    'data': PropTypes.shape({
      'previousPayment': PropTypes.array,
    }),
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
  'getParkingProblems': PropTypes.shape({
    'data': PropTypes.array,
  }),
  'getProblems': PropTypes.array,
  'createPayment': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'paymentID': PropTypes.string,
    }),
  }),
  'updatePayment': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'getPaymentDetail': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'getProfile': PropTypes.shape({}),
  'getVehicleLicensePlate': PropTypes.shape({
    'data': PropTypes.any,
  }),
  'iotDevices': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'publishIoTInformation': PropTypes.shape({}),
  'carExit': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
};

const mapStateToProps = ({
  getParkingStatus,
  getBuildingByRefNo,
  getParkingProblems,
  getProblems,
  createPayment,
  updatePayment,
  getPaymentDetail,
  getProfile,
  getVehicleLicensePlate,
  iotDevices,
  publishIoTInformation,
  carExit,  
}) => ({
  getParkingStatus,
  'getBuildingByRefNo': getBuildingByRefNo.data,
  getParkingProblems,
  'getProblems': getProblems.data,
  createPayment,
  updatePayment,
  getPaymentDetail,
  'getProfile': getProfile.data,
  'getVehicleLicensePlate': getVehicleLicensePlate.data,
  iotDevices,
  publishIoTInformation,
  carExit,
});

export default connect(mapStateToProps)(withRouter(ParkingStatus));
